import SkapaModal, {
  type ModalAttributes,
  ModalBody,
  type ModalFooterAttributes,
  type ModalFooterProps,
  type ModalHeaderAttributes,
  type ModalHeaderProps,
  type ModalProps,
  type SheetsAttributes,
  type SheetsProps,
  ModalFooter as SkapaModalFooter,
  ModalHeader as SkapaModalHeader,
  Sheets as SkapaSheets,
} from "@ingka/modal";

const Modal = (props: ModalProps & ModalAttributes) => {
  return (
    <SkapaModal prefix="saleslead__" {...props}>
      {props.children}
    </SkapaModal>
  );
};

const Sheets = (props: SheetsProps & SheetsAttributes) => {
  return (
    <SkapaSheets prefix="saleslead__" {...props}>
      {props.children}
    </SkapaSheets>
  );
};

const ModalHeader = (props: ModalHeaderProps & ModalHeaderAttributes) => {
  return (
    <SkapaModalHeader prefix="saleslead__" {...props}>
      {props.children}
    </SkapaModalHeader>
  );
};

const ModalFooter = (props: ModalFooterProps & ModalFooterAttributes) => {
  return (
    <SkapaModalFooter prefix="saleslead__" {...props}>
      {props.children}
    </SkapaModalFooter>
  );
};

export { Modal, ModalBody, ModalFooter, ModalHeader, Sheets, type SheetsProps };
